export const translationHI = {
  top: {
    text_1: 'ताजा भोजन और बेहतर ग्रह',
    text_2: 'एआई अनुशंसा करता है',
    text_3: 'हजारों नुस्खे',
    text_4: 'एक ऐसी जगह जो आपको सामग्री प्रबंधित करने में मदद करती है',
    text_5: 'कई व्यंजनों से रेसिपी',
    text_6: 'साप्ताहिक मेनू, खरीदारी सूची',
  },
  main_function: {
    text_1: 'मुख्य सुविधाएँ',
    text_1_1: 'अपना खाना ताजा रखें!',
    text_1_2: 'हमारे फ्रेशनेस चेकर से अलर्ट प्राप्त करें ताकि खाना बर्बाद न हो',
    text_2_1: 'एआई रेसिपी सुझाव',
    text_2_2: 'अपने फ्रिज में बची सामग्री के आधार पर दुनिया भर के कई व्यंजनों से रेसिपी खोजें',
    text_3_1: 'पूरे सप्ताह के लिए मेनू',
    text_3_2: 'पूरे सप्ताह के लिए मेनू बनाएं',
    text_4_1: 'खरीदारी सूची',
    text_4_2: 'खरीदारी यात्राओं के लिए तैयार होने के लिए खरीदारी सूची बनाएं और अपडेट करें',
    text_5: 'डाउनलोड करें',
    text_6: 'iFridge आपकी मदद करेगा',
    text_7_1: 'एक बेहतर गृहिणी बनें',
    text_7_2: 'कचरे को कम करें और एक स्वस्थ ग्रह बनाएं',
    text_7_3: 'खाना पकाने का आनंद लें',
  },
  rate_box: {
    text_1: 'उपयोगकर्ता समीक्षा',
  },
  faqs: {
    text_1: 'अक्सर पूछे जाने वाले प्रश्न',
    text_2_1: 'कौन-कौन से प्रकार के खाते हैं? क्या मैं ऐप का मुफ्त में उपयोग कर सकता हूँ?',
    text_2_2: `आप पहले महीने के लिए ऐप की सभी सुविधाओं का मुफ्त में और बिना विज्ञापन के उपयोग कर सकते हैं।
      <br /><br />पहले महीने के बाद, आपका खाता स्वतः ही एक फ्री अकाउंट में बदल जाएगा।
      <br /><br />फ्री अकाउंट के साथ, आप ऐप की बुनियादी सुविधाओं का उपयोग कर सकते हैं, जैसे: सामग्री प्रबंधन, दैनिक सामग्री स्थिति रिपोर्ट। आप कुछ उन्नत सुविधाओं का उपयोग नहीं कर पाएंगे, जैसे: एआई रेसिपी सुझाव, साप्ताहिक मेनू, खरीदारी सूची। ऐप का उपयोग करते समय विज्ञापन भी दिखाई देंगे।
      <br /><br />ऐप की सभी सुविधाओं का विज्ञापन मुक्त उपयोग करने के लिए, आपको एक प्रीमियम अकाउंट में अपग्रेड करना होगा, जो एक बहुत ही उचित मासिक लागत पर उपलब्ध है।`,
    text_3_1: 'प्रीमियम अकाउंट की लागत कितनी है?',
    text_3_2: `आप मासिक या वार्षिक सदस्यता ले सकते हैं।
      <br /><br />मासिक लागत: $0.99/माह।
      <br /><br />वार्षिक लागत: $9.99/वर्ष।
      <br /><br />कोई अन्य शुल्क नहीं है।`,
    text_4_1: 'क्या मैं बिना पैसे खर्च किए प्रीमियम अकाउंट ले सकता हूँ?',
    text_4_2: `बिलकुल।
      <br /><br />प्रीमियम अकाउंट की सदस्यता लेने के लिए, आप iFridge पॉइंट्स का उपयोग कर सकते हैं।
      <br /><br />iFridge पॉइंट्स को ऐप स्टोर/गूगल प्ले के माध्यम से खरीदा जा सकता है: सेटिंग स्क्रीन पर, पॉइंट्स मेनू पर टैप करें जो आपको पॉइंट्स खरीदने वाली स्क्रीन पर ले जाएगा।
      <br /><br />या आप विज्ञापन देखकर iFridge पॉइंट्स कमा सकते हैं: सेटिंग स्क्रीन पर, अन्य सेटिंग्स मेनू पर टैप करें, फिर विज्ञापन देखें।`,
    text_5_1: 'क्या मैं विज्ञापन देखने से iFridge पॉइंट्स कमा सकता हूँ?',
    text_5_2: `आप विज्ञापन देखकर iFridge पॉइंट्स कमा सकते हैं।
      <br /><br />आपके देश के अनुसार, प्रत्येक विज्ञापन देखने पर आपको एक निश्चित संख्या में iFridge पॉइंट्स मिलेंगे (गूगल ऐडमॉब नियमों के अनुसार)। एक विज्ञापन देखने के बाद, आपको अगला विज्ञापन देखने के लिए 20 मिनट तक इंतजार करना होगा।`,
    text_6_1: 'क्या मैं दोस्तों को रेफर करके iFridge पॉइंट्स कमा सकता हूँ?',
    text_6_2: `आप दोस्तों को रेफर करके निश्चित रूप से iFridge पॉइंट्स कमा सकते हैं।
      <br /><br />आपके देश के अनुसार, फेसबुक, ट्विटर आदि जैसे सोशल नेटवर्क पर iFridge की जानकारी साझा करके आपको एक निश्चित संख्या में iFridge पॉइंट्स मिल सकते हैं।
      <br /><br />एक महीने में, आप रेफरल के लिए केवल एक बार iFridge पॉइंट्स प्राप्त कर सकते हैं।`,
    text_7_1: 'क्या मेरे व्यक्तिगत डेटा सुरक्षित हैं? क्या इन्हें तृतीय पक्षों के साथ साझा किया जाता है?',
    text_7_2:
      'आपका डेटा पूरी तरह से आपके फ़ोन पर संग्रहीत है और पूरी तरह से सुरक्षित है। हम आपके व्यक्तिगत डेटा को अपने सर्वर पर संग्रहीत नहीं करते हैं और न ही इसे किसी तृतीय पक्ष के साथ साझा करते हैं।',
    text_8_1: 'यदि मुझे सहायता की आवश्यकता हो, तो मैं कैसे संपर्क करूँ?',
    text_8_2: `आप हमसे संपर्क कर सकते हैं 'हमसे संपर्क करें' फ़ंक्शन के माध्यम से: सेटिंग स्क्रीन पर, अन्य सेटिंग्स का चयन करें, फिर हमसे संपर्क करें।
      <br /><br />या सहायता अनुरोध/प्रतिक्रिया सीधे इस ईमेल पर भेजें: ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: 'प्यार आ सकता है और जा सकता है,',
    text_2: 'लेकिन भूख हर दिन आती है',
  },
};
